import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ae68b68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "q-mt-md q-mr-md" }
const _hoisted_3 = { class: "machine-name q-pr-md q-pt-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EquipmentSelector = _resolveComponent("EquipmentSelector")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_EquipmentSelector)
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.getEquipmentDetails?.name), 1 /* TEXT */)
  ]))
}